// extracted by mini-css-extract-plugin
module.exports = {"firstKV":"FirstKV_firstKV__ID8VE","ef-box":"FirstKV_ef-box__lecfs"};